// extracted by mini-css-extract-plugin
export var icon = "SocialsNavigation-module--icon--fd20c";
export var link = "SocialsNavigation-module--link--6e75b";
export var linkWrapper = "SocialsNavigation-module--linkWrapper--23579";
export var mobileOnly = "SocialsNavigation-module--mobileOnly--e5849";